namespace Ir.Components.PDFTemplate.PDFTemplateEditor {

    interface IViewModel {
        pdfTemplates: Array<PdfTemplate>;
        dataGridConfig: DevExpress.ui.dxDataGrid.Properties;
        companies: Array<Classes.Models.Company>
        organizations: Array<Organization>
    }
    interface IParams {
        callback: (obj) => boolean;
    }

    let popupComponent: DevExpress.ui.dxPopup;
    let gridComponent: DevExpress.ui.dxDataGrid;
    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;

        let o = {
            url: urlConfigs.pdfTemplate + "GetPdfTemplatesEditor",
            data: {},
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result, e) {
            self.companies = [new Classes.Models.Company({ id: 0, name: "", organisationId: 0 }), ...createInstances(Classes.Models.Company, result.companies ?? [])];
            self.organizations = [new Organization({ id: 0, name: "" }), ...createInstances(Organization, result.organizations ?? [])]
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get PDF templates";
            self.companies = [];
            self.organizations = [];
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        this.pdfTemplates = PDFTemplatesService.getPDFTemplates(true, 0);
        this.dataGridConfig = {
            height: 330,
            width: "100%",
            paging: {
                enabled: false
            },
            dataSource: this.pdfTemplates,
            columns: [
                {
                    dataField: "name",
                    caption: "Name",
                    sortOrder: "asc",
                    validationRules: [{
                        message: "Name is not unique",
                        type: 'custom',
                        validationCallback: function (e) {
                            let valid = self.pdfTemplates.filter(function (x) { return x.name == e.value && x.id !== e.data.id; }).length == 0;
                            return valid;
                        }
                    }, {
                        type: "custom",
                        validationCallback: function (v) {
                            if (v.value === undefined || v.value === null) {
                                return false;
                            }

                            if (v.value.trim() === "") {
                                return false;
                            }

                            return true;
                        },
                        message: "Name is required"
                    }]
                },
                {
                    dataField: "mappingId",
                    caption: "Mapping",
                    visible: true,
                    setCellValue(rowData, value) {
                        this.defaultSetCellValue(rowData, value, undefined);
                    },
                    lookup: {
                        dataSource: [{ id: 0, name: ' ' }, ...MappingService.mappings],
                        displayExpr: 'name',
                        valueExpr: 'id',
                    }
                },
                {
                    dataField: "organisationId",
                    caption: "Organisation",
                    visible: workbook.workbookConfig.appBar.multiTenant,
                    setCellValue(rowData, value) {
                        this.defaultSetCellValue(rowData, value, undefined);
                        rowData.companyId = 0;
                    },
                    lookup: {
                        dataSource: self.organizations,
                        displayExpr: 'name',
                        valueExpr: 'id',
                    }
                },
                {
                    dataField: "companyId",
                    caption: "Company",
                    visible: workbook.workbookConfig.appBar.multiTenant,
                    lookup: {
                        dataSource(options) {
                            let pdfTemplate: PdfTemplate = options.data;
                            return {
                                store: self.companies,
                                filter: pdfTemplate ? [['organisationId', '=', pdfTemplate.organisationId], 'or', ['organisationId', '=', 0]] : null,
                            };
                        },
                        displayExpr: 'name',
                        valueExpr: 'id',
                    }
                },
                {
                    dataField: "config.header",
                    visible: false
                },
                {
                    dataField: "config.footer",
                    visible: false
                },
                {
                    type: "buttons",
                    name: "editHeader",
                    caption: "Header",
                    width: 80,
                    buttons: [{
                        hint: "Edit Header",
                        icon: "edittableheader",
                        disabled: function (e) {
                            return !e.row.isEditing;
                        },
                        onClick: function (e) {
                            let pdfTemplate: PdfTemplate = e.row.data;
                            showHtmlEditor(pdfTemplate, pdfTemplate.config.header, (value, height) => {
                                let rowIndex = e.component.getRowIndexByKey(pdfTemplate.id);
                                if (rowIndex === -1) {
                                    rowIndex = 0;
                                }

                                if (height > 0) {
                                    e.component.cellValue(rowIndex, "config.headerHeight", parseInt(height as any, 10));
                                }

                                e.component.cellValue(rowIndex, "config.header", value);
                                return true;
                            });
                        }
                    }]
                },
                {
                    type: "buttons",
                    name: "editFooter",
                    caption: "Footer",
                    width: 80,
                    buttons: [{
                        hint: "Edit Footer",
                        icon: "rowproperties",
                        disabled: function (e) {
                            return !e.row.isEditing;
                        },
                        onClick: function (e) {
                            let pdfTemplate: PdfTemplate = e.row.data;
                            showHtmlEditor(pdfTemplate, pdfTemplate.config.footer, (value, height) => {
                                let rowIndex = e.component.getRowIndexByKey(pdfTemplate.id);
                                if (rowIndex === -1) {
                                    rowIndex = 0;
                                }

                                if (height > 0) {
                                    e.component.cellValue(rowIndex, "config.footerHeight", parseInt(height as any, 10));
                                }

                                e.component.cellValue(rowIndex, "config.footer", value);
                                return true;
                            });
                        }
                    }]
                },
                {
                    dataField: "config.headerHeight",
                    caption: "Header Height",
                    format: function (value) { return `${value}mm`; },
                    width: 95,
                    editorOptions: {
                        min: 0,
                        showSpinButtons: true,
                        format: '0#mm'
                    }
                },
                {
                    dataField: "config.footerHeight",
                    caption: "Footer Height",
                    width: 95,
                    format: function (value) { return `${value}mm`; },
                    editorOptions: {
                        min: 0,
                        showSpinButtons: true,
                        format: '0#mm'
                    }
                },
                {
                    type: "buttons",
                    buttons: [{
                        name: "edit",
                        visible: function (e) {
                            let pdfTemplate: PdfTemplate = e.row.data;
                            if (workbook.workbookConfig.appBar.multiTenant && (!pdfTemplate.organisationId || pdfTemplate.organisationId === 0) && !loggedUser.permissions.pdfTemplates()) {
                                return false;
                            }
                            return true;
                        }
                    }, {
                        name: "delete",
                        visible: function (e) {
                            let pdfTemplate: PdfTemplate = e.row.data;
                            if (workbook.workbookConfig.appBar.multiTenant && (!pdfTemplate.organisationId || pdfTemplate.organisationId === 0) && !loggedUser.permissions.pdfTemplates()) {
                                return false;
                            }
                            return true;
                        }
                    }, {
                        hint: "Clone",
                        icon: "copy",
                        visible: function (e) {
                            return !e.row.isEditing;
                        },
                        onClick: function (e) {
                            let clonedItem = new PdfTemplate(e.row.data);
                            clonedItem.id = 0;
                            clonedItem.name += "- Copy";

                            let newName = clonedItem.name;
                            let countName = 1;
                            while (self.pdfTemplates.filter(function (x) { return x.name == newName; }).length > 0) {
                                newName = `${clonedItem.name} ${countName}`;
                                countName++;
                            }
                            clonedItem.name = newName;

                            if (workbook.workbookConfig.appBar.multiTenant && (!clonedItem.organisationId || clonedItem.organisationId === 0) && !loggedUser.permissions.pdfTemplates()) {
                                clonedItem.organisationId = loggedUser.orgId();
                            }

                            e.component.getDataSource().store().push([{ type: "insert", data: clonedItem }]);
                            clonedItem.save(true, function () {
                                e.component.option("focusedRowKey", clonedItem.id);
                            });
                        }
                        }, {
                            hint: "PDF Template Info",
                            icon: "contentlayout",
                            onClick: function (e) {
                                let pdfTemplate: PdfTemplate = e.row.data;
                                Ir.Components.General.ForeignKeyInfo.show({
                                    title: `PDF Template Info: ${pdfTemplate.name}`,
                                    url: `${urlConfigs.pdfTemplate}PdfTemplateInfo/${pdfTemplate.id}`,
                                    createTabs(result) {
                                        return [
                                            {
                                                name: "Scheduled Emails",
                                                dataSource: result.scheduledEmails,
                                                columns: [
                                                    { dataField: "scheduledEmailId", caption: "Id", dataType: "string" },
                                                    { dataField: "scheduledEmailName", caption: "Name" },
                                                    { dataField: "workbookName", caption: "Workbook" },
                                                    {
                                                        type: 'buttons',
                                                        width: 50,
                                                        buttons: [{
                                                            hint: 'Open workbook',
                                                            icon: 'link',
                                                            onClick(e) {
                                                                let o = {
                                                                    url: `${urlConfigs.tabs}CanAccessWorkbook`,
                                                                    data: {
                                                                        userId: loggedUser.id(),
                                                                        workbookId: e.row.data.workbookId,
                                                                        companyId: loggedUser.companyId()
                                                                    },
                                                                    dataType: "json",
                                                                    async: false,
                                                                } as RequestServerParams;
                                                                o.successFunction = function (data) {
                                                                    if (data.success) {
                                                                        window.open(`${window.location.origin}/wb/edit/${e.row.data.workbookId}`, '_blank').focus();
                                                                    }
                                                                    else {
                                                                        DevExpress.ui.notify(data.message);
                                                                    }
                                                                };
                                                                o.failureFunction = function () {
                                                                    DevExpress.ui.notify("Workbook not found or no access permission");
                                                                };

                                                                irGlobal.requestServer(o);
                                                            }
                                                        }],
                                                    }
                                                ]
                                            }
                                        ];
                                    }
                                } as Ir.Components.General.ForeignKeyInfo.IForeignKeyInfoParams);
                            }
                        }]
                }
            ],
            showBorders: true,
            editing: {
                mode: "row",
                allowUpdating: true,
                allowDeleting: true,
                allowAdding: true,
                useIcons: true,
            },
            focusedRowEnabled: true,
            keyExpr: "id",
            focusedRowIndex: 0,
            scrolling: {
                useNative: false
            },
            onInitialized(e) {
                gridComponent = e.component;
            },
            onInitNewRow(e) {
                let pdfTemplate = new PdfTemplate();
                pdfTemplate.mappingId = workbook.workbookConfig.mappingId;//??

                let newName = pdfTemplate.name;
                let countName = 1;
                while (self.pdfTemplates.filter(function (x) { return x.name == newName; }).length > 0) {
                    newName = `${pdfTemplate.name} ${countName}`;
                    countName++;
                }
                if (workbook.workbookConfig.appBar.multiTenant && !loggedUser.permissions.pdfTemplates()) {
                    pdfTemplate.organisationId = loggedUser.orgId();
                }

                pdfTemplate.name = newName;
                e.data = pdfTemplate;
            },
            onRowInserted(e) {
                e.data.save(true, function () {
                    e.component.option("focusedRowKey", e.data.id);
                });
            },
            onRowUpdated(e) {
                e.data.save();
            },
            onRowRemoving(e) {
                let deferred = $.Deferred();
                let pdfTemplate: PdfTemplate = e.data;
                pdfTemplate.delete(function () {
                    deferred.resolve();
                }, function (failureText) {
                    deferred.reject(failureText);
                });
                e.cancel = deferred.promise();
            },
            onEditorPrepared(options) {
                if (workbook.workbookConfig.appBar.multiTenant && options.dataField == 'organisationId') {
                    if (!loggedUser.permissions.pdfTemplates()) {
                        options.editorElement.dxSelectBox('instance').option("disabled", true);
                    }
                    else {
                        options.editorElement.dxSelectBox('instance').option("disabled", false);
                    }
                }
            },
            onEditorPreparing(e) {
                if (e.dataField === "mappingId") {
                    e.editorOptions.dropDownOptions = {
                        width: 300
                    };
                }
            }
        }
    }

    function showHtmlEditor(pdfTemplate: PdfTemplate, value: string, onSaving: (value: string, height: number) => boolean) {
        let variables: Array<VariableHtmlEditor> = [];
        for (let variable of PDFTemplatesService.variables) {
            variables.push(new VariableHtmlEditor(variable.name, variable.value));
        }

        let filtersVM = getFilters(pdfTemplate);
        Ir.Components.Workbook.Settings.Items.HtmlEditorSetting.show({
            value: value,
            onSaving: onSaving,
            menuOptions: [{
                name: 'Variables',
                icon: "ms ir-buttons-alt-icon",
                items: variables
            }, {
                name: 'Filters',
                icon: "ms ir-filter_alt-icon",
                items: filtersVM,
                visible: filtersVM.length > 0
            }],
            useFilters: true
        } as Ir.Components.Workbook.Settings.Items.HtmlEditorSetting.IHtmlEditorSettings);
    }

    function getFilters(pdfTemplate: PdfTemplate) {
        let filters: Array<VariableRichText> = [];
        if (pdfTemplate.mappingId > 0) {
            const mapping = MappingService.getMapping(pdfTemplate.mappingId);
            for (let filter of mapping.visibleFilters) {
                filters.push(new VariableRichText(VariableTypeEnum.Filter, filter.name, filter.filterEditorType, VariableFilterTypeEnum.Default));
            }

            let filterVariables = getFilterVariables();
            for (let filter of filters) {
                if (filter.filterEditorType === FilterEditorTypeEnum.Date || filter.filterEditorType === FilterEditorTypeEnum.DateRange) {
                    let isDateRange = filter.filterEditorType === FilterEditorTypeEnum.DateRange;
                    for (let variable of filterVariables) {
                        if (variable.range === isDateRange || variable.range === undefined) {
                            filter.items.push(new VariableRichText(VariableTypeEnum.Filter, filter.name, filter.filterEditorType, filter.filterType, variable));
                        }
                    }
                }
            }
        }

        return filters;
    }

    export function show() {
        if (popupComponent) {
            popupComponent.show();
        }
        else {
            let popupOptions = {
                width: workbook.workbookConfig.appBar.multiTenant ? 1000 : 800,
                height: 390,
                showTitle: true,
                title: "PDF Templates",
                visible: false,
                dragEnabled: false,
                hideOnOutsideClick: false,
                showCloseButton: true,
                position: {
                    at: "center",
                    my: "center",
                },
                onInitialized(e) {
                    popupComponent = e.component;
                    popupComponent.show();
                },
                onShown() {
                    if (gridComponent) {
                        gridComponent.updateDimensions();
                    }
                },
                onHiding() {
                    if (gridComponent) {
                        gridComponent.cancelEditData();
                    }
                }
            } as DevExpress.ui.dxPopover.Properties;

            let $popover = $(`
            <div data-bind="dxPopup: popupOptions">
                <pdftemplates-editor></pdftemplates-editor>
            </div>`);
            $popover.appendTo('body');

            ko.applyBindings({ popupOptions }, $popover[0]);
        }
    }
}